<template>
    <div class="login flexbox-center flex-row">
        <div class="flex-div login-left">
            <h1 v-if="!showSelect">Velkommen</h1>
            <form v-if="!showSelect" class="login-container" v-on:submit.prevent="onSubmit">
                <div class="input-svg">
                    <icon class="user small-svg" name="user"></icon>
                    <input type="text" class="username" placeholder="Email" v-model="user.username" autofocus>
                </div>
                <div class="input-svg">
                    <icon class="locked small-svg" name="locked"></icon>
                    <input type="password" class="password" placeholder="Adgangskode" v-model="user.password">
                </div>
                <button type="submit" class="button">{{loginMessage}}</button>
                <a class="text-center display-block">Glemt kodeord?</a>
                <p class="text-center error" :class="{'hidden': !error}">{{errorMessage}}</p>
            </form>
            <div v-else>
                <div class="login-container-bigger">
                    <h1 class="text-center margin-bottom-20">Vælg regnskab</h1>
                    <div v-if="regnskabList" v-for="regnskab in regnskabList()" :key="regnskab.id" @click="selectRegnskab(regnskab)" :class="{'selected': selectedRegnskab === regnskab}" class="list-row grid-x">
                        <div class="large-12 cell flexbox-align-items">
                            <span>{{regnskab.beskrivelse}}</span>
                        </div>
                    </div>
                    <button type="button" class="button" :class="{'disabled': !selectedRegnskab}" @click="acceptRegnskab()">Vælg</button>
                </div>
            </div>
            <div class="bottom">
                <div class="flexbox-center flex-column">
                    <div>
                        <icon class="logo niraslogo" name="niraslogo"></icon>
                    </div>
                    <div>
                        <p>VALUE - en del af <b>NIRAS</b>UTILITY</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-div login-right">
            <div class="background-image"></div>
            <div class="overlay flexbox-center">
                <div class="flex-div">
                    <h1 class="logo">VALUE</h1>
                    <p>- holder styr på værdierne</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/store/api.js'

export default {
    name: 'login',
    data () {
        return {
            user: {
                username: '',
                password: '',
                rememberme: false
            },
            loginMessage: '',
            errorMessage: 'Ingen fejl',
            error: false,
            // supply
            showSelect: false,
            // regnskab
            selectedRegnskab: null
        }
    },
    computed: {
        ...mapGetters({
            regnskabList: 'getRegnskabList'
        })
    },
    methods: {
        ...mapActions({
            getCurrentUserInfo: 'getCurrentUserInfo',
            getAllCodeLists: 'getAllCodeLists',
            getRegnskabList: 'getRegnskabList',
            setSelectedRegnskab: 'setSelectedRegnskab'
        }),
        async onSubmit () {
            this.error = false
            if (this.user.username.trim() !== '') {
                if (this.user.password.trim() !== '') {
                    try {
                        this.loginMessage = 'Logger ind...'
                        const response = await axios.post('/Account/SignIn', this.user)
                        if (response) {
                            await this.getCurrentUserInfo()
                            await this.getAllCodeLists()
                            await this.getRegnskabList()

                            this.showSelect = true
                        }
                    } catch (err) {
                        this.error = true
                        this.errorMessage = 'Noget gik galt. Prøv igen'
                        this.loginMessage = 'Log ind'
                        console.log('err login', err)
                    }
                } else {
                    this.error = true
                    this.errorMessage = 'Indtast adgangskode'
                    this.loginMessage = 'Log ind'
                }
            } else {
                this.error = true
                this.errorMessage = 'Indtast brugernavn'
                this.loginMessage = 'Log ind'
            }
        },
        selectRegnskab (regnskab) {
            this.selectedRegnskab = regnskab
        },
        async acceptRegnskab () {
            try {
                await this.setSelectedRegnskab(this.selectedRegnskab)

                this.$router.push({
                    name: 'dashboard'
                })
            } catch (err) {
                console.log('err accept regnskab', err)
            }
        }
    },
    created () {
        this.loginMessage = 'Log ind'
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/login.vue